// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./draggable.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_draggableBlockMenu__pKpbM {
    border-radius: 4px;
    
    cursor: grab;
    opacity: 0;
    position: absolute;
    z-index: 100000;
    
    left: -10px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    width: 24px;
    height: 24px;
    will-change: transform;
  }
  
  .styles_draggableBlockMenu__pKpbM .styles_icon__yY\\+rJ {
    z-index: 1000;
    width: 22px;
    height: 22px;
    opacity: 0.3;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-position-x: center;
  }
  
  .styles_draggableBlockMenu__pKpbM:active {
    cursor: grabbing;
    z-index: 1000;
  }
  
  .styles_draggableBlockMenu__pKpbM:hover {
    z-index: 1000;
  }
  
  .styles_draggableBlockTargetLine__xUdOo {
    pointer-events: none;
    background: #8FB4FF;
    height: 2px;
    position: absolute;
    left: -10px;
    top: 0;
    opacity: 0;
    will-change: transform;
  }`, "",{"version":3,"sources":["webpack://./src/components/form/Editor/plugins/DraggableBlockPlugin/styles.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,eAAe;;IAEf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mDAAgC;IAChC,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,UAAU;IACV,sBAAsB;EACxB","sourcesContent":[".draggableBlockMenu {\n    border-radius: 4px;\n    \n    cursor: grab;\n    opacity: 0;\n    position: absolute;\n    z-index: 100000;\n    \n    left: -10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 0;\n    width: 24px;\n    height: 24px;\n    will-change: transform;\n  }\n  \n  .draggableBlockMenu .icon {\n    z-index: 1000;\n    width: 22px;\n    height: 22px;\n    opacity: 0.3;\n    background: url(./draggable.svg);\n    background-position: center;\n    background-position-x: center;\n  }\n  \n  .draggableBlockMenu:active {\n    cursor: grabbing;\n    z-index: 1000;\n  }\n  \n  .draggableBlockMenu:hover {\n    z-index: 1000;\n  }\n  \n  .draggableBlockTargetLine {\n    pointer-events: none;\n    background: #8FB4FF;\n    height: 2px;\n    position: absolute;\n    left: -10px;\n    top: 0;\n    opacity: 0;\n    will-change: transform;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"draggableBlockMenu": `styles_draggableBlockMenu__pKpbM`,
	"icon": `styles_icon__yY+rJ`,
	"draggableBlockTargetLine": `styles_draggableBlockTargetLine__xUdOo`
};
export default ___CSS_LOADER_EXPORT___;
